import React, { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import { useTheme } from '@mui/material/styles';

import DynamicPropertyField from './DynamicPropertyField';
import { getDynVals } from '../../utils/DynHelper';

const DynamicPropertyTable = ({ rows, disabled, selectedValues, setDefaultValues, groupState }) => {
  const theme = useTheme();
  const ui = theme.palette.ui;
  const { setFieldValue } = useFormikContext();
  const { group } = groupState;
  const [filteredRows, setFilteredRows] = useState(rows);

  useEffect(() => {
    if (rows.length > 0) {
      const dynObj = getDynVals(rows, selectedValues?.dynamicProperties);

      if (Object.keys(dynObj).length > 0) {
        setDefaultValues((prev) => ({ ...prev, dynamicFields: dynObj }));
        setFieldValue('dynamicFields', dynObj);
      }
    }
  }, [rows, setFieldValue, setDefaultValues]);

  useEffect(() => {
    if (group?.id && group.id.length > 0) {
      const newFilteredRows = rows.filter((row) =>
        row.property.formPropertyGroup?.some((groupItem) => group.id.includes(groupItem.groupId))
      );
      setFilteredRows(newFilteredRows);
    } else {
      setFilteredRows(rows);
    }
  }, [group?.id, rows]);

  return (
    <div className="max-h-[400px] overflow-y-scroll overflow-x-hidden custom-scrollbar mt-5">
      <table className="border w-full">
        <thead style={{ background: ui.tableHeader }}>
          <tr className="grid grid-cols-4">
            <th className="border p-3 col-span-2">Megnevezés</th>
            <th className="border p-3 col-span-2">Érték</th>
          </tr>
        </thead>
        <tbody>
          {filteredRows.map((row, index) => (
            <tr key={row.property.id} className={index % 2 === 0 ? 'bg-gray-100 grid grid-cols-4' : 'grid grid-cols-4'}>
              <td className="border py-1 col-span-2">{row.property.name}</td>
              <td className="border py-1 col-span-2 relative">
                <div className="relative w-full">
                  <DynamicPropertyField
                    fieldData={row}
                    name={`dynamicFields.din_${row.property.id}`}
                    disabled={disabled}
                    selectedValues={selectedValues}
                  />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DynamicPropertyTable;
